import { z } from "zod";

const CSS_COLOR =
  /^(#[0-9a-f]{3,8}|(?:rgb|hsl|hwb|lab|lch|oklab|oklch)a?\([\d\s.,%/+-]+\)|[a-z]{3,20})$/i;

const color = z
  .string()
  .trim()
  .regex(CSS_COLOR)
  .optional()
  .nullable()
  .catch(null);

const EmbedStylesSchema = z.object({
  accentColor: color,
  surfaceColor: color,
  surfaceAltColor: color,
  backgroundColor: color,
  topColor: color,
  textForegroundColor: color,
  textForegroundAltColor: color,
  textMuted: color,
  textMutedAlt: color,
  borderColor: color,
  borderColorAlt: color,
});

const EmbedConfigSchema = z.object({
  renderOrderSummary: z.boolean().optional().default(false),
  renderBusiness: z.boolean().optional().default(false),
  renderImageCarousel: z.boolean().optional().default(false),
  renderConcept: z.boolean().optional().default(false),
  styles: EmbedStylesSchema.optional(),
});

type EmbedConfig = z.infer<typeof EmbedConfigSchema>;

export { EmbedConfigSchema, type EmbedConfig };
